const footerLinks = [
  {
    title: 'Sortiment',
    links: ['Edelsplitt', 'Gabionensteine', 'Dekosteine', 'Zubehör'],
  },
  {
    title: 'Unternehmen',
    links: ['Über uns', 'Portfolio', 'Referenzen', 'Kontakt'],
  },
  {
    title: 'Rechtliches',
    links: ['Impressum', 'Datenschutzerklärung'],
  },
];

export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ backgroundColor: '#1D1D1F' }} className="text-white pt-20 pb-10 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://public.readdy.ai/ai/img_res/74fdf9a5-9580-4fb2-84d1-9c0b79777fd0.png"
              alt="Ziersteine.de Logo"
              className="h-10 w-auto object-contain mb-6"
            />
            <p className="text-stone-400 text-sm leading-relaxed mb-6 max-w-xs">
              Natursteine aus aller Welt — für zeitlose Eleganz in Ihrem Garten, Vorgarten und Ihrer Außenanlage.
            </p>
            <div className="space-y-2">
              <a
                href="mailto:ziersteine@spickermann-gmbh.net"
                className="flex items-center gap-2 text-stone-400 hover:text-white text-sm transition-colors"
              >
                <i className="ri-mail-line text-xs" />
                ziersteine@spickermann-gmbh.net
              </a>
              <a
                href="tel:+4938204693597"
                className="flex items-center gap-2 text-stone-400 hover:text-white text-sm transition-colors"
              >
                <i className="ri-phone-line text-xs" />
                038204 / 693597
              </a>
              <p className="flex items-start gap-2 text-stone-400 text-sm">
                <i className="ri-map-pin-2-line text-xs mt-0.5 flex-shrink-0" />
                Rostocker Landstrasse 3a, 18184 Broderstorf
              </p>
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-white font-medium text-sm mb-5">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <button
                      onClick={() => scrollTo(`#${link.toLowerCase().replace(/\s+/g, '-')}`)}
                      className="text-stone-400 hover:text-white text-sm transition-colors cursor-pointer"
                    >
                      {link}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-xs">
            &copy; {new Date().getFullYear()} Ziersteine.de – Natursteine aus aller Welt. Alle Rechte vorbehalten.
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center gap-2 text-stone-400 hover:text-white text-xs transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line text-sm" />
            Nach oben
          </button>
        </div>
      </div>
    </footer>
  );
}
